<template>
  <div class="notfound">お探しのページは見つかりませんでした。</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.notfound {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
